import { Outlet, useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import Sidebar from "./Sidebar";
import Header from "./Header";
import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Button,
	  Card, 
	  CardBody,
	  CardHeader,
	  CardTitle, 
	  Modal,
	  ModalBody,
	  ModalFooter,
	  ModalHeader,
	  Input,
	  Label,
	  Row,
	  Col, 
	  FormGroup,
	  Table } from "reactstrap";
import { useRef } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { getDefaultRoute, USER_TYPES,
	api,
	onlyNumber,
	socket,
	SOCKET,
	SHOW_CLOCK_IN_OUT_PERMISSION_ID,
	SHOW_NO_SALES_PERMISSION_ID,
	USER_ROLES,
	DB_FORMAT,
	WORKING_LOG_EVENT,
	EMPLOYEE_WORKING_STATUS,
	SUPER_ADMIN_LOGIN_ID,
	LOCAL_STORAGE_USER as LOCAL_STORAGE_USER_KEY,
} from "../util";
import Select from 'react-select'
import { getUsersRequest } from "../redux/actions";

const AuthenticatedLayout = ({ children , showSidebar = true , topAlignHeader = null }) => {
  const sidebarRef = useRef(null)
  const dispatch = useDispatch();
  const { role, id, email, firstName, lastName, manage_saloons } = useSelector((state) => state.user);
  const { users } = useSelector((state) => state.users);
  const navigate = useNavigate();
  const hideMobileMenu = () => {
    document.getElementById("sidebarArea").classList.remove("showSidebar");
  };
  
  const user = useSelector((state) => state.user);
  const [showClockInOutModal , setShowClockInOutModal] = useState(false);
  const [employeeWorkingLog , setEmployeeWorkingLog] = useState([]);
  const [eventName , setEventName] = useState("");
  const { permissions } = useSelector((state) => state.user);
  var miPopup = false;
  
  const [showNoSalesPopupModal , setShowNoSalesPopupModal] = useState(false);
  const [employeeBookingLog , setEmployeeBookingLog] = useState([]);
  const [noSalesLogId , setNoSalesLogId] = useState(null);
  const [employeeScheduleInfo , setEmployeeScheduleInfo] = useState([]);
  
  const [isLoading, setIsLoading] = useState(false);
  /*
  useEffect(() => {
	    dispatch(getUsersRequest({
	        filter: {
	          onlyAdmin:true,
	        },
	      }));
  }, []);
  */
  
  useEffect(() => {
      if (!socket) return;
        socket.emit(SOCKET.EMIT_JOIN, {
          roomId: "SUPER_ADMIN",
          from: {
            id : user?.id,
            accountId : user?.accountId,
            role : (user?.accountId && user.accountId > 0 ? USER_ROLES.ACCOUNT : USER_ROLES.SUPER_ADMIN)
          }
        });

      socket.on("disconnected", (data) => {
        
      });    

      return () => {
        socket.off(SOCKET.EMIT_JOIN);
      };
  }, []);
  
  useEffect(() => {
	  	if (!socket) return;
	    socket.on(SOCKET.RECEIVE_DISPLAY_NOTIFICATION, () => {
	    	console.log("RECEIVE_DISPLAY_NOTIFICATION 111")
	    	showClockInClockOutEntryPopup();
	    });
	    return () => {
	      socket.off(SOCKET.RECEIVE_DISPLAY_NOTIFICATION);
	    };
  }, []);
  
  useEffect(() => {
	 	if (!socket) return;
	    socket.on(SOCKET.RECEIVE_SALOON_SEAT_CHANGED, (data) => {
	    	console.log("RECEIVE_SALOON_SEAT_CHANGED");
	    	if (id) {
	    		getUserSeatedShopDetails(id);
	        }
	    });
	    return () => {
	      socket.off(SOCKET.RECEIVE_SALOON_SEAT_CHANGED);
	    };
}, []);

const [requestOTPNumber , setRequestOTPNumber] = useState(null);
  
  const showClockInClockOutEntryPopup = async () => {
      try {
          const response = await api.get('/timesheet/getEmployeeClockInClockOutInfo');
          console.log("showClockInClockOutEntryPopup response" , response );
          if(response.status === 200) {
              if(response?.data?.data) {
            	  const record_type = response?.data?.data?.record_type;
            	  if (response?.data?.data?.notificationRecord?.id) {
            		  var recordEventName = record_type;
            		  setNotificationRecordType(response?.data?.data?.record_type);
                	  setShowNotificationPopup(true);
                	  setNotificationRecordId(response?.data?.data?.notificationRecord?.id);
					  setRequestOTPNumber(response?.data?.data?.SalesOtpNumber)
                	  setNotificationRecordInfo(response?.data?.data?.notificationRecord);
                	  setEventName(recordEventName);
                	  setNotificationAdditionalRecordInfo(response?.data?.data?.additionalRecordInfo);
                	  if (record_type === "MISS_CLOCK_IN" || record_type === "Early Clock Out" || record_type === "Late Clock Out" ){
                		  setNotificationEmployeeName(response?.data?.data?.notificationRecord?.Employee?.firstName + ' ' + response?.data?.data?.notificationRecord?.Employee?.lastName)
                		  setNotificationSaloonName(response?.data?.data?.notificationRecord?.Saloon?.name)
                		  setEmployeeScheduleInfo(response?.data?.data?.additionalRecordInfo);
                		  setEmployeeWorkingLog(response?.data?.data?.workingLogDetails);
                	 }
            	  }
              }
          }
      } catch (error) {
          toast.error(error.response?.data?.message || error.message);
      }
  }
  
  const updateNoSalesPopupStatus = async () => {
	  
	 // console.log("noSalesLogId" , noSalesLogId )
	  try {
          if( noSalesLogId ) {
        	  const response = await api.post('/timesheet/updateNoSalesPopupStatus',{'noSalesLogId' : noSalesLogId });
              if(response.status === 200) {
            	  miPopup = false;
            	  setShowNoSalesPopupModal(false);
    	  		  showClockInClockOutEntryPopup();
            	  
              }
          } else {
        	  miPopup = false;
        	  setShowNoSalesPopupModal(false);
          }
	  } catch (error) {
          toast.error(error.response?.data?.message || error.message);
      }
      
  }
  
  const setReminderForNoSalesPopup = async () => {
	  
	  if( reminderTime == 0 ){
		  alert("Please Select Reminder Time");
		  return false;
		  
	  }
	  // console.log("reminderTime" , reminderTime );
	  // console.log("noSalesLogId" , noSalesLogId )
	  try {
          if( noSalesLogId ) {
        	  const response = await api.post('/timesheet/updateNoSalesPopupStatus',{'noSalesLogId' : noSalesLogId, 'reminderTime' : reminderTime });
              if(response.status === 200) {
            	  miPopup = false;
            	  setShowNoSalesPopupModal(false);
    	  		  showClockInClockOutEntryPopup();
            	  
              }
          } else {
        	  miPopup = false;
        	  setShowNoSalesPopupModal(false);
          }
	  } catch (error) {
          toast.error(error.response?.data?.message || error.message);
      }
  }
  
  const setReminderCancelStatus = async () => {
	  setShowReminderSection(false);
  }
  
   useEffect(() => {
	  showClockInClockOutEntryPopup()
  }, []);

  var viewIndex = 1;
  const diffBetweenTimeIntoJS = (start_time = null , end_time = null) => {
		
      var currentDate = moment().format("YYYY-MM-DD") ;
  	
      start_time = currentDate + ' ' + start_time ;
      
  	if( end_time === null || end_time === "" ){
  		end_time = moment().format(DB_FORMAT.TIME);
  	}
		end_time = currentDate + ' ' + end_time;
		
		var time_diff = '';
		var diff =  Math.abs(new Date(start_time) - new Date(end_time));
		var seconds = 0;
		if( start_time !== "" && start_time !== null && end_time !== "" && end_time !== null  ){

			var timeStart = new Date(start_time);
			var timeEnd = new Date(end_time);

			if(timeStart > timeEnd){
				var start_diff = timeStart - new Date( currentDate + " 23:59");
			   	var end_diff = new Date( currentDate + " 12:00 AM") - timeEnd;

				time_diff = start_diff + end_diff;
				diff = Math.abs(time_diff);
				
				seconds = Math.floor(diff/1000); // ignore any left over
													// units smaller than a
													// second
				seconds = ( parseFloat( seconds )  > 0 ? ( seconds + 60 ) : seconds );
			} else {
				time_diff = timeStart - timeEnd;
			    diff = Math.abs(time_diff);
				
			    seconds = Math.floor(diff/1000); // ignore any left over
													// units smaller than a
													// second
				
			}
		}
		
		var minutes = Math.floor(seconds/60); 
		
		seconds = seconds % 60;
		var hours = Math.floor(minutes/60);
		minutes = minutes % 60;

		var timeDiff = '';
		if( parseFloat(hours)  > 0.00 && parseFloat(minutes) > 0.00 ){
			timeDiff = hours + (  parseFloat(hours) > 1 ? ' hrs ' : ' hr ' ) +   minutes + (  parseFloat(minutes) > 1 ? ' mins' : ' min' );
		} else {
			if( parseFloat(hours)  > 0 ){
				timeDiff = hours + (  parseFloat(hours) > 1 ? ' hrs ' : ' hr ' );
			}
			if( parseFloat(minutes)  >= 0 ){
				timeDiff = minutes + (  parseFloat(minutes) > 1 ? ' mins' : ' min' );
			}
		}
		// console.log("timeDiff" , timeDiff );
		return timeDiff;
  }
  const [showReminderSection , setShowReminderSection] = useState(false);
  const [reminderTime , setReminderTime] = useState(0);
  
  const approvedSeatRequest = async() => {
	  setIsLoading(true)
	  try {
          if( notificationRecordId ) {
        	  const response = await api.post('/users/updateSeatApprovalStatus',{ 'seatApprovedRecordId' : notificationRecordId });
              if(response.status === 200) {
            	  miPopup = false;
            	  setShowNotificationPopup(false);
            	  socket.emit(SOCKET.EMIT_SALOON_SEAT_CHANGED,{});
    	  		  socket.emit(SOCKET.EMIT_DISPLAY_NOTIFICATION,{});
              }
          } else {
        	  miPopup = false;
        	  setShowNotificationPopup(false);
          }
	  } catch (error) {
          toast.error(error.response?.data?.message || error.message);
      } finally {
	        setIsLoading(false);
      }
  }
  
  const [statusOfSeatRequestModal , setStatusOfSeatRequestModal] = useState(false);
  const [sendSeatAllocationRequestPopup, setSendSeatAllocationRequestPopup] = useState(false);
  
  const updateEmployeeScheduleReminderStatus = async(scheduleStatus) => {
	  if (notificationRecordId) {
		  setIsLoading(true)
		  try {
		      const response = await api.post("/users/updateEmployeeScheduleNotification",  {'scheduleStatus' : scheduleStatus, 'employeeApprovalRecordId' :  notificationRecordId } );
		      if(response.status === 200) {
		    	  setShowNotificationPopup(false)
		    	  socket.emit(SOCKET.EMIT_DISPLAY_NOTIFICATION,{});
		      }
		  } catch (error) {
		      toast.error(error.response?.data?.message || error.message);
		  } finally {
			  setIsLoading(false);
		  }
	  }
  }
 
 const [loggedUserInfo, setLoggedUserInfo] = useState([]);
 const [seatedShopDetails, setSeatedShopDetails] = useState([]);
 const [usersOptions, setUsersOptions] = useState([]);
 const [sendSeatAllocationPopup, setSendSeatAllocationPopup] = useState(false);
 
 useEffect(() => {
	    var currentLoggedUserInfo = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
    	var currentLoggedUserInfoJson = JSON.parse(currentLoggedUserInfo);
    	setSeatedShopDetails(currentLoggedUserInfoJson?.Saloons);
    	setLoggedUserInfo(currentLoggedUserInfoJson)
 }, []);
 
 useEffect(() => {
	    dispatch(getUsersRequest({
	        filter: {
	          onlyAdmin:true,
	        },
	    }));
	    var userSelection = [];
	  	userSelection.push({ 'label' : 'Select' , 'value' : '' });
	  	users.forEach((_, index) => {
		  if (_.id !== SUPER_ADMIN_LOGIN_ID && _.id !== id) {
		    userSelection.push({ value: _.id, label: _.firstName });
		  }
	  	});
	  	setUsersOptions(userSelection);
}, [sendSeatAllocationPopup]);
 
 const getUserSeatedShopDetails = async (id) => {
		try {
			const getSeatedShopDetails = await api.get("/users/getUserWithSeatSalonDetails/" + id);
	        if (getSeatedShopDetails.status === 200) {
	        	setSeatedShopDetails ( getSeatedShopDetails?.data?.data?.Saloons );
	        	setLoggedUserInfo(getSeatedShopDetails?.data?.data);
	        	
	        	var currentLoggedUserInfo = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
		    	var currentLoggedUserInfoJson = JSON.parse(currentLoggedUserInfo);
		    	currentLoggedUserInfoJson.Saloons = getSeatedShopDetails?.data?.data?.Saloons;
		    	currentLoggedUserInfoJson.manage_saloons = getSeatedShopDetails?.data?.data?.manage_saloons;
		    	currentLoggedUserInfoJson.on_lunch = getSeatedShopDetails?.data?.data?.on_lunch;
		    	currentLoggedUserInfoJson.manage_saloons = getSeatedShopDetails?.data?.data?.manage_saloons;
		    	localStorage.setItem(LOCAL_STORAGE_USER_KEY,JSON.stringify(currentLoggedUserInfoJson));
	        	
	        }
		} catch (error) {
			toast.error(error.response?.data?.message || error.message);
		} 
	};
	
	
	
	  
	  
	  var saloonWiseNewManagerIds = [];
	  const setNewManageIds = async (e, field_name) => {
		  const newManagerId = e;
		  const shopId = parseInt(field_name.split("_").pop()); // "11"
		  const index = saloonWiseNewManagerIds.findIndex(item => item.shopId === shopId);

		  if (index !== -1) {
			  saloonWiseNewManagerIds[index].newManagerId = newManagerId;
		  } else {
			  saloonWiseNewManagerIds.push({ shopId, newManagerId });
		  }
	 };
	 
	 const sendSeatToOtherManager = async() => {
		  const shopIds = saloonWiseNewManagerIds.map(item => (item.shopId));
		  var error_found = false;
			  seatedShopDetails.map((seatedShopDetail, index) => {
				  if (!shopIds.includes(seatedShopDetail.id)) {
					  error_found = true;
				  }
			  })
			  if (error_found !== false){
				  toast.error("Please select New Seat Manager For All Salons.");
				  return false;
			  }
			  setIsLoading(true)
			  try {
			      const response = await api.post("/users/setNewManagerNotification",  {'manager_ids' : saloonWiseNewManagerIds } );
			      if(response.status === 200) {
			    	  setSendSeatAllocationPopup(false)
			    	  socket.emit(SOCKET.EMIT_DISPLAY_NOTIFICATION,{});
			      }
			  } catch (error) {
			      toast.error(error.response?.data?.message || error.message);
			  } finally {
				 setIsLoading(false);
			  }
		}
 
 
 const [showNotificationPopup , setShowNotificationPopup] = useState(false);
 const [notificationRecordId , setNotificationRecordId] = useState(null);
 const [notificationRecordType , setNotificationRecordType] = useState(null);
 const [notificationRecordInfo , setNotificationRecordInfo] = useState([]);
 const [notificationAdditionalRecordInfo , setNotificationAdditionalRecordInfo] = useState([]);
 const [notificationEmployeeName , setNotificationEmployeeName] = useState(null);
 const [notificationSaloonName , setNotificationSaloonName] = useState(null);
 
 const updateStatusApiCall = async (updateStatusPayload) => {
	 try {
         if( notificationRecordId ) {
          const response = await api.post('/timesheet/updateClockInOutPopupStatus',updateStatusPayload);
             if(response.status === 200) {
            	 if (eventName === "block_user_screen"){
            		 toast.success(response?.data?.message);
            	 }
            	 miPopup = false;
           	  	 setShowNotificationPopup(false);
           	  	 socket.emit(SOCKET.EMIT_DISPLAY_NOTIFICATION,{});
           	 } else if(response.status === 404) {
           		toast.error(response?.data?.message || response.message);
           	 }
         } else {
        	 miPopup = false;
        	 setShowNotificationPopup(false);
         }
	  } catch (error) {
         toast.error(error.response?.data?.message || error.message);
     }
}
 
 const validateUserOTP = async () => {
	 try {
         if( notificationRecordId ) {
        	 if (verifyOTPNumber === null || verifyOTPNumber === "" || verifyOTPNumber.length !== 6){
	       		  toast.error("Please Enter Valid OTP");
	       		  return false;
	       	  }
        	 updateStatusApiCall({'workingLogId' : notificationRecordId,  'eventName' : eventName, 'verifyOTPNumber' : verifyOTPNumber});
         }
	  } catch (error) {
         toast.error(error.response?.data?.message || error.message);
     }
}
 
 const resendUserOTP = async () => {
	 try {
		 const response = await api.post('/users/resendOTP',{});
         if(response.status === 200) {
        	 toast.success(response?.data?.message);
         } else if(response.status === 404) {
       		toast.error(response?.data?.message || response.message);
       	 }
	  } catch (error) {
         toast.error(error.response?.data?.message || error.message);
     }
}
 
 
 
 
 const updateNotificationStatus = async () => {
	 updateStatusApiCall({'workingLogId' : notificationRecordId, 'eventName' : eventName  });
 }
 
 const updateLateClockOutStatus = async (action_name) => {
	  if (action_name == "continue"){
		  if (notificationRecordInfo) {
			  var popupEmployeeId = notificationRecordInfo?.employeeId;
			  var popupSaloonId = notificationRecordInfo?.saloonId;
			  if (popupEmployeeId && popupSaloonId) {
				  var redirectScheduleObj = {
						  employee_id: popupEmployeeId,
						  saloon_id: popupSaloonId
				 };
				 var redirectScheduleToken = btoa(JSON.stringify(redirectScheduleObj));
				 navigate("/schedules/add?token=" + redirectScheduleToken);
			 }
		  }
	  }
	  updateStatusApiCall({'workingLogId' : notificationRecordId,  'eventName' : eventName, 'action_name' : action_name});
 }
 
  const updateNoSalesOpenDrawerRequest = async (action_name) => {
	 if (noSalesOpenDrawerRemark === null || noSalesOpenDrawerRemark === ""){
		  toast.error("Please Enter No Sales Open Drawer Reason/ Remark");
		  return false;
	  }
	  updateStatusApiCall({'workingLogId' : notificationRecordId,   'eventName' : eventName  , 'noSalesOpenDrawerRemark' : noSalesOpenDrawerRemark  });
}
 
 const [approveRejectEarlyClockOutRemark , setApproveRejectEarlyClockOutRemark] = useState(null);
 const [earlyClockOutStatus , setEarlyClockOutStatus] = useState(null);
 const handleEarlyClockOutRemark = (e) => {
	  	setApproveRejectEarlyClockOutRemark(e.target.value);
 }
 
 const [noSalesOpenDrawerRemark , setNoSalesOpenDrawerRemark] = useState(null);
 const handleNoSalesOpenDrawerRemark = (e) => {
	 setNoSalesOpenDrawerRemark(e.target.value);
}
 
 const [verifyOTPNumber , setVerifyOTPNumber] = useState(null);
 
 const approveRejectEarlyClockOut = async () => {
	  if (approveRejectEarlyClockOutRemark === null || approveRejectEarlyClockOutRemark === ""){
		  toast.error("Please Enter Early Clock Out Reason/ Remark");
		  return false;
	  }
	  updateStatusApiCall({'workingLogId' : notificationRecordId,   'eventName' : eventName  , 'earlyClockOutStatus' : earlyClockOutStatus,  'approveRejectEarlyClockOutRemark' : approveRejectEarlyClockOutRemark });
 }
 
 
 const [employeeName , setEmployeeName] = useState("");
 const [showEmployeeSchedulePopupModal , setShowEmployeeSchedulePopupModal] = useState(false);
 const [employeeApprovalRecordId , setEmployeeApprovalRecordId] = useState(null);
 const [userManagedShopDetails , setUserManagedShopDetails] = useState(null);
  
  return (
    <main>
      {/** ******header********* */}
      <Header hideMobileMenu={hideMobileMenu}
      	setLoggedUserInfo={setLoggedUserInfo}
        loggedUserInfo={loggedUserInfo}
        setSeatedShopDetails={setSeatedShopDetails}
        seatedShopDetails={seatedShopDetails}
        setSendSeatAllocationPopup={setSendSeatAllocationPopup}
     />
      <div className="pageWrapper d-lg-flex">
        {/** ******Sidebar********* */}
        <aside  ref={sidebarRef} className={"sidebarArea shadow " + ( showSidebar !== true ? 'd-none' : '')  } data-ss={showSidebar} id="sidebarArea">
          <Sidebar sidebarRef={sidebarRef}  />
        </aside>
        {/** ******Content Area********* */}
        <div className={"contentArea " + ( ( topAlignHeader !== null && topAlignHeader !== "" ) ? topAlignHeader : '' )  } onClick={hideMobileMenu}>
          {/** ******Middle Content********* */}
          <Container className="p-4" fluid>
            {children}
          </Container>
		  
          /*
	     <Modal isOpen={showNoSalesPopupModal}  className="clock-summary-modal" size="lg" centered>
	        <ModalHeader>
	            <h5 className="mb-0 fw-bolder"><span className="text-danger" style={{fontSize: '15px'}}>No Sales</span> {employeeName !== "" ? ' - ' + employeeName : ''}</h5>
	        </ModalHeader>
	        <ModalBody className="p-0">
	        <Card className="newdashboard-table shadow-none mb-0">
	            <CardBody className="px-2 py-0">
	            <Table responsive>
	                <thead>
	                <tr>
	                    <th className="text-center" style={{minWidth: '110px',width: '110px'}}>Sr. No.</th>
	                    <th className="text-center" style={{minWidth: '180px' ,width: '180px'}}>Booking Time</th>
	                    <th className="text-center" style={{minWidth: '110px',width: '110px'}}>Booking Amount</th>
	                </tr>
	                </thead>
	                <tbody>
	                    {employeeBookingLog !== null && employeeBookingLog?.length > 0 ? (
	                    		employeeBookingLog.map((empBookingInfo , index) => (
	                            <tr>
	                                <td className="text-center">{viewIndex++}</td>
	                                <td className="text-center">{empBookingInfo?.transactionId}</td>
	                                <td className="text-center">{empBookingInfo?.netTotal}</td>
	                            </tr>
	                        ))
	                    ) : (
	                        <>
	                            <td colSpan={3} className="text-center" ><span className="fw-bolder">No Data Found</span></td>
	                        </>
	                    )}
	                </tbody>
	            </Table>
	            </CardBody>
	            { (showReminderSection) && (
	            		<Card className="newdashboard-table shadow-none mb-0">
		            		<CardHeader>
		                    	<CardTitle tag="h5">Reminder</CardTitle>
		                    </CardHeader>
		            		<CardBody>
				            	<div className="d-flex gap-2">
					            	<Input id="reminder_5_minute" 
				                	  	type="radio"
				                	  	name="reminder_time_selection"
				                	  	onClick={() => {
				                	  		setReminderTime(5);
					                    }}
					            	/>
					            	<Label htmlFor="reminder_5_minute" className="mx-1 px-1">5 Minutes</Label>
					            	<Input id="reminder_10_minute" 
				                	  	type="radio"
				                	  	name="reminder_time_selection"
				                	  	onClick={(e) => {
				                	  		setReminderTime(10);
					                    }}
					            	/>
					            	<Label htmlFor="reminder_10_minute" className="mx-1 px-1">10 Minutes</Label>
					            	<Input id="reminder_15_minute" 
				                	  	type="radio"
				                	  	name="reminder_time_selection"
				                	  	onClick={(e) => {
				                	  		setReminderTime(15)
					                    }}
					            	/>
					            	<Label htmlFor="reminder_15_minute" className="mx-1 px-1">15 Minutes</Label>
					            </div>
					        </CardBody>
					    </Card>
	            
	            )}
	            
	        </Card>
	        </ModalBody>
	        <ModalFooter>
	        	{ showReminderSection != true && (
	        		<>	
	        			<Button color="dark" className="btn-sm m-2" onClick={ () => { setShowReminderSection(true) }}>Set Reminder</Button>
	        			<Button color="success" className="btn-sm m-0" onClick={updateNoSalesPopupStatus}>Close</Button>
	        		</>
	        	)}
	        	{ showReminderSection != false && (
	        		<>
	        			<Button color="dark" className="btn-sm m-2" onClick={setReminderCancelStatus}>Cancel Reminder</Button>
	        			<Button color="success" className="btn-sm m-0" onClick={setReminderForNoSalesPopup}>Submit</Button>
	        		</>
	        	)}
	        	
	            
	        </ModalFooter>
	  </Modal>
	  
	  */
	  {showEmployeeSchedulePopupModal === true && (
				<Modal isOpen={showEmployeeSchedulePopupModal}  className="clock-summary-modal" size="lg" centered>
			      <ModalHeader>
			          <h5 className="mb-0 fw-bolder"><span className="text-danger" style={{fontSize: '15px'}}>Employee Schedule Reminder</span></h5>
			      </ModalHeader>
			      <ModalBody className="p-0">
			      <Card className="newdashboard-table shadow-none mb-0">
			          <CardBody className="px-2 py-0">
			          <Table responsive>
			              <thead>
			              <tr>
			                  <th className="text-center" style={{minWidth: '110px',width: '110px'}}>Sr. No.</th>
			                  <th className="text-center" style={{minWidth: '180px' ,width: '180px'}}>Salon Name</th>
			              </tr>
			              </thead>
			              <tbody>
			              {userManagedShopDetails !== null && userManagedShopDetails?.length > 0 ? (
			            		  userManagedShopDetails.map((userManagedShopDetail , index) => (
			                      <tr>
			                          <td className="text-center">{++index}</td>
			                          <td className="text-center">{userManagedShopDetail?.name}</td>
			                      </tr>
			                  ))
			              ) : (
			                  <>
			                      <td colSpan={3} className="text-center" ><span className="fw-bolder">No Data Found</span></td>
			                  </>
			              )}
			              </tbody>
			          </Table>
			          </CardBody>
			      </Card>
			      </ModalBody>
			      <ModalFooter>
			      	<>
			      		<Button color="success" className="btn-sm m-2" 
			      			onClick={(e) => {
			      				updateEmployeeScheduleReminderStatus('completed')
		                    }}
			      			>Mark As Completed
			      		</Button>
		      			<Button color="danger" className="btn-sm m-2" 
			      			onClick={(e) => {
			      				updateEmployeeScheduleReminderStatus('pending')
		                    }}
			      			>Mark As Pending
			      		</Button>	
			      			
			      	</>
			      </ModalFooter>
			</Modal>
		)}
	    

		
		
		{showNotificationPopup === true && (
				<Modal isOpen={showNotificationPopup}  className="clock-summary-modal" size="lg" centered>
			     <ModalHeader>
			     	<h4 className="mb-0 fw-bolder">
			     	{ notificationRecordType !== "" && notificationRecordType === 'not_seated_saloon'  && (
			        		<>	
			        			
			        				<span className="text-success text-center" style={{fontSize: '26px'}}>
			        				Unassigned Saloon List
			        				</span>
			        			
			        		</>
			     	)}
					{ notificationRecordType !== "" && notificationRecordType === 'EMPLOYEE_SCHEDULE'  && (
			        		<>	
			        			
			        				<span className="text-success text-center" style={{fontSize: '26px'}}>
			        				Saloon Schedule Reminder
			        				</span>
			        			
			        		</>
			     	)}
					{ notificationRecordType !== "" && notificationRecordType === 'no_sales_drawer_open'  && (
			        		<>	
			        			<span className="text-success text-center" style={{fontSize: '26px'}}>
			        				No Sales Drawer Open Request
			        			</span>
			        		</>
			     	)}
			     	 { notificationRecordType !== "" && notificationRecordType === 'assign_saloon_seat'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					New Saloon Assigned
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'seat_reassign_seat_request'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					Salon Reassigned – Observation not required
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'block_user_screen'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					OTP Verification - Missed Salon Schedule
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'send_seat_request_approve'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					Salon Request Accepeted
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'seat_accept_request'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					New Salon Request Received 
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'seat_pending_request'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					Pending Salon Request - Hold on! 
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'MISS_CLOCK_IN'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					Miss Clock In Notification
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'Early Clock Out'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					Early Clock Out Notification
				        				</span>
				        			
				        		</>
				     )}
				     { notificationRecordType !== "" && notificationRecordType === 'Late Clock Out'  && (
				        		<>	
				        			
				        				<span className="text-success text-center" style={{fontSize: '26px'}}>
				        					Late Clock Out for Notification
				        				</span>
				        			
				        		</>
				     )}
				     </h4>
			     </ModalHeader>
			      <ModalBody className="p-0">
			      <Card className="newdashboard-table shadow-none mb-0">
			          <CardBody className="px-2 py-0">
			          { notificationRecordType !== "" && notificationRecordType === 'assign_saloon_seat'  && (
				        		<>
				        		<h5 style={{margin: '20px'}}>
				        			You have been assigned to <span className="text-danger text-center" ><b>{notificationAdditionalRecordInfo?.name}</b></span>.
				        			<br/>
				        			Please review the details and proceed with your tasks.
				        		</h5>
				        		</>
			          )}
			          { notificationRecordType !== "" && notificationRecordType === 'block_user_screen'  && (
				        		<>
				        		<Row>
								<Col xl={6} md={6} sm={12} xs={12}>
									<FormGroup>
										<Label for="confirmation_code">
											Enter Confirmation Code
										</Label>
										<input
											onChange={(e) => {
												setVerifyOTPNumber(e.target.value);
											}}
											id="confirmation_code"
											name="confirmation_code"
											placeholder="Confirmation Code"
											type="text"
											maxLength={6}
											autoComplete="off"
											className={
												"form-control"
											}
										/>
									</FormGroup>
								</Col>
							</Row>
				        		</>
			          )}
			          { notificationRecordType !== "" && notificationRecordType === 'seat_reassign_seat_request'  && (
				        		<>
				        		<br/>
				        		<h5 style={{margin: '24px'}}>
				        			Shop <b>{notificationAdditionalRecordInfo?.name}</b> is now reassigned. No need for further observation.
				        		</h5>
				        		<br/>
				        		</>
			          )}
			          { notificationRecordType !== "" && notificationRecordType === 'MISS_CLOCK_IN'  && (
				        		<>
				        		<br/>
				        		<h5 style={{margin: '20px'}}>
				        		<span className="text-danger" style={{fontSize: '22px'}}>{notificationEmployeeName}</span> has not clocked in at Salon <span className="text-danger" style={{fontSize: '22px'}}>{notificationSaloonName}</span>. Please take necessary action.
				        		</h5>
				        		<br/>
				        		<div style={{ display: "flex", margin: '30px' , justifyContent: "space-between" }}>
				        		  <span><b>Scheduled In:</b> <span className="text-success text-center" style={{fontSize: '24px'}}>{moment(employeeScheduleInfo?.startTime, DB_FORMAT.TIME).format("hh:mm A")}</span></span>
				        		  <span><b>Scheduled Out:</b> <span className="text-danger text-center" style={{fontSize: '24px'}}>{moment(employeeScheduleInfo?.endTime, DB_FORMAT.TIME).format("hh:mm A")}</span></span>
				        		</div>
				        		 
			        		 	
				        		</>
			          )}
			         
			          { notificationRecordType !== "" && notificationRecordType === 'send_seat_request_approve'  && (
				        		<>
				        		<br/>
				        		<h5 className="text-center" style={{ fontSize: '20px' }}>
				        			Seat request accepted. You’re cleared to go out for lunch/work.
				        		</h5>
				        			<br/>
				        		</>
			          )}
					   { notificationRecordType !== "" && notificationRecordType === 'no_sales_drawer_open'  && (
				        		<>
				        		<br/>
					        		<h5 className="text-center" style={{ fontSize: '20px' }}>
					        			Salon <b>{notificationAdditionalRecordInfo?.name}</b> has sent a "No Sales – Open Drawer" request.<br/>
					        			The OTP for this request is {requestOTPNumber}
					        		</h5>
				        		<br/>
				        		<CardBody className="px-2 py-0 early-clock-out-div">
				        		    <Row>
					                <Col xl={6}>
				                      <FormGroup>
					                      <textarea
					                      id="no_sales_open_drawer_remark"
					                      name="no_sales_open_drawer_remark"
					                      placeholder="No Sales Open Drawer Reason/ Remark"
					                      type="textarea"
				                    	  onChange={(e) => {
				                    		  handleNoSalesOpenDrawerRemark(e);
				  	                      }}
					                      rows={3}
					                      className={"form-control"}
					                    />
				                      </FormGroup>
				                      </Col>
				                  </Row>
				                </CardBody>
				        		</>
			          )}
			          {notificationRecordType !== "" && notificationRecordType === 'not_seated_saloon' && (
			        		  <>
			        		  	<br/>
			        		  	<h5 className="text-center text-danger" style={{ fontSize: '27px' }}>This Salons Not assigned. Please do needfull.</h5>
			        		  	<br/>
			        		    <Table responsive>
			        		      <thead>
			        		        <tr>
			        		          <th className="text-center" style={{ minWidth: '110px', width: '110px' }}>Sr. No.</th>
			        		          <th className="text-center" style={{ minWidth: '180px', width: '180px' }}>Salon Name</th>
			        		        </tr>
			        		      </thead>
			        		      <tbody>
			        		      	{console.log("notificationAdditionalRecordInfo 1", notificationAdditionalRecordInfo)}
			        		      	{(notificationAdditionalRecordInfo) && notificationAdditionalRecordInfo.length > 0 ? (
				        		    		  (() => {
				        		    		    const rows = [];
				        		    		    notificationAdditionalRecordInfo.forEach((notificationAdditionalRecord, index) => {
				        		    		      rows.push(
				        		    		        <tr key={index}>
				        		    		          <td className="text-center">{index + 1}</td>
				        		    		          <td className="text-center">{notificationAdditionalRecord?.name}</td>
				        		    		        </tr>
				        		    		      );
				        		    		    });
				        		    		    return rows;
				        		    		  })()
				        		    		) : (
				        		    		  <tr>
				        		    		    <td colSpan={2} className="text-center">
				        		    		      <span className="fw-bolder">No Data Found</span>
				        		    		    </td>
				        		    		  </tr>
				        		    		)}
			        		      </tbody>
			        		    </Table>
			        		  </>
			        		)}
			          {notificationRecordType !== "" && notificationRecordType === 'EMPLOYEE_SCHEDULE' && (
			        		  <>
			        		  	<br/>
			        		  	<h5 className="text-center text-danger" style={{ fontSize: '27px' }}>You need to schedule the following salons.</h5>
			        		  	<br/>
			        		    <Table responsive>
			        		      <thead>
			        		        <tr>
			        		          <th className="text-center" style={{ minWidth: '110px', width: '110px' }}>Sr. No.</th>
			        		          <th className="text-center" style={{ minWidth: '180px', width: '180px' }}>Salon Name</th>
			        		        </tr>
			        		      </thead>
			        		      <tbody>
			        		      	{console.log("notificationAdditionalRecordInfo 1", notificationAdditionalRecordInfo)}
			        		      	{(notificationAdditionalRecordInfo) && notificationAdditionalRecordInfo.length > 0 ? (
				        		    		  (() => {
				        		    		    const rows = [];
				        		    		    notificationAdditionalRecordInfo.forEach((notificationAdditionalRecord, index) => {
				        		    		      rows.push(
				        		    		        <tr key={index}>
				        		    		          <td className="text-center">{index + 1}</td>
				        		    		          <td className="text-center">{notificationAdditionalRecord?.name}</td>
				        		    		        </tr>
				        		    		      );
				        		    		    });
				        		    		    return rows;
				        		    		  })()
				        		    		) : (
				        		    		  <tr>
				        		    		    <td colSpan={2} className="text-center">
				        		    		      <span className="fw-bolder">No Data Found</span>
				        		    		    </td>
				        		    		  </tr>
				        		    		)}
			        		      </tbody>
			        		    </Table>
			        		  </>
			        		)}
			          {notificationRecordType !== "" && notificationRecordType === 'seat_pending_request' && (
			        		  <>
			        		  	<br/>
			        		  	<h5 className="text-center text-danger" style={{ fontSize: '27px' }}>Don’t go For Lunch Until Every Location Is Approved.</h5>
			        		  	<br/>
			        		    <Table responsive>
			        		      <thead>
			        		        <tr>
			        		          <th className="text-center" style={{ minWidth: '110px', width: '110px' }}>Sr. No.</th>
			        		          <th className="text-center" style={{ minWidth: '180px', width: '180px' }}>Salon Name</th>
			        		        </tr>
			        		      </thead>
			        		      <tbody>
			        		      	{console.log("notificationAdditionalRecordInfo 1", notificationAdditionalRecordInfo)}
			        		      	{(notificationAdditionalRecordInfo) && notificationAdditionalRecordInfo.length > 0 ? (
				        		    		  (() => {
				        		    		    const rows = [];
				        		    		    notificationAdditionalRecordInfo.forEach((notificationAdditionalRecord, index) => {
				        		    		      rows.push(
				        		    		        <tr key={index}>
				        		    		          <td className="text-center">{index + 1}</td>
				        		    		          <td className="text-center">{notificationAdditionalRecord?.name}</td>
				        		    		        </tr>
				        		    		      );
				        		    		    });
				        		    		    return rows;
				        		    		  })()
				        		    		) : (
				        		    		  <tr>
				        		    		    <td colSpan={2} className="text-center">
				        		    		      <span className="fw-bolder">No Data Found</span>
				        		    		    </td>
				        		    		  </tr>
				        		    		)}
			        		      </tbody>
			        		    </Table>
			        		  </>
			        		)}
			          {notificationRecordType !== "" && notificationRecordType === 'seat_accept_request' && (
			        		  <>
			        		    <Table responsive>
			        		      <thead>
			        		        <tr>
			        		          <th className="text-center" style={{ minWidth: '110px', width: '110px' }}>Sr. No.</th>
			        		          <th className="text-center" style={{ minWidth: '180px', width: '180px' }}>Salon Name</th>
			        		        </tr>
			        		      </thead>
			        		      <tbody>
			        		      {console.log("notificationAdditionalRecordInfo 2", notificationAdditionalRecordInfo)}
			        		      {(notificationAdditionalRecordInfo) && notificationAdditionalRecordInfo.length > 0 ? (
			        		    		  (() => {
			        		    		    const rows = [];
			        		    		    notificationAdditionalRecordInfo.forEach((notificationAdditionalRecord, index) => {
			        		    		      rows.push(
			        		    		        <tr key={index}>
			        		    		          <td className="text-center">{index + 1}</td>
			        		    		          <td className="text-center">{notificationAdditionalRecord?.name}</td>
			        		    		        </tr>
			        		    		      );
			        		    		    });
			        		    		    return rows;
			        		    		  })()
			        		    		) : (
			        		    		  <tr>
			        		    		    <td colSpan={2} className="text-center">
			        		    		      <span className="fw-bolder">No Data Found</span>
			        		    		    </td>
			        		    		  </tr>
			        		    		)}
			        		      </tbody>
			        		    </Table>
			        		  </>
			        		)}
			          </CardBody>
			          {notificationRecordType !== "" && 
			        	  (notificationRecordType === "Late Clock Out" || notificationRecordType === "Early Clock Out") && (
			        	   <>
			        	     <h5 style={{ margin: "20px" }}>
			        	       <span className="text-danger" style={{ fontSize: "22px" }}>
			        	         {notificationEmployeeName}
			        	       </span>{" "}
			        	       {notificationRecordType} For Salon{" "}
			        	       <span className="text-danger" style={{ fontSize: "22px" }}>
			        	         {notificationSaloonName}
			        	       </span>
			        	       . Please take necessary action.
			        	     </h5>

			        	     <div
			        	       style={{
			        	         display: "flex",
			        	         margin: "10px 30px",
			        	         justifyContent: "space-between",
			        	       }}
			        	     >
			        	       <span>
			        	         <b>Scheduled In:</b>{" "}
			        	         <span
			        	           className="text-success text-center"
			        	           style={{ fontSize: "24px" }}
			        	         >
			        	           {moment(employeeScheduleInfo?.startTime, DB_FORMAT.TIME).format(
			        	             "hh:mm A"
			        	           )}
			        	         </span>
			        	       </span>
			        	       <span>
			        	         <b>Scheduled Out:</b>{" "}
			        	         <span
			        	           className="text-danger text-center"
			        	           style={{ fontSize: "24px" }}
			        	         >
			        	           {moment(employeeScheduleInfo?.endTime, DB_FORMAT.TIME).format(
			        	             "hh:mm A"
			        	           )}
			        	         </span>
			        	       </span>
			        	     </div>

			        	     <Table responsive className="d-none">
			        	       <thead>
			        	         <tr>
			        	           <th className="text-center" style={{ minWidth: "110px", width: "110px" }}>
			        	             Sr. No.
			        	           </th>
			        	           <th className="text-center" style={{ minWidth: "180px", width: "180px" }}>
			        	             Start Time
			        	           </th>
			        	           <th className="text-center" style={{ minWidth: "110px", width: "110px" }}>
			        	             End Time
			        	           </th>
			        	         </tr>
			        	       </thead>
			        	       <tbody>
			        	         {employeeWorkingLog && employeeWorkingLog.length > 0 ? (
			        	           employeeWorkingLog.map((workingLogInfo, index) => (
			        	             <tr key={index}>
			        	               {workingLogInfo?.event === WORKING_LOG_EVENT.WORK && (
			        	                 <>
			        	                   <td className="text-center">{viewIndex++}</td>
			        	                   <td className="text-center">
			        	                     {workingLogInfo?.startTime
			        	                       ? moment(workingLogInfo.startTime, DB_FORMAT.TIME).format(
			        	                           "hh:mm A"
			        	                         )
			        	                       : " - "}
			        	                   </td>
			        	                   <td className="text-center">
			        	                     {workingLogInfo?.endTime
			        	                       ? moment(workingLogInfo.endTime, DB_FORMAT.TIME).format(
			        	                           "hh:mm A"
			        	                         )
			        	                       : " - "}
			        	                   </td>
			        	                 </>
			        	               )}
			        	               {workingLogInfo?.event === WORKING_LOG_EVENT.BREAK && (
			        	                 <td colSpan={3} className="text-center">
			        	                   <span className="fw-bolder">Break Time: </span>
			        	                   {workingLogInfo?.startTime
			        	                     ? diffBetweenTimeIntoJS(
			        	                         workingLogInfo.startTime,
			        	                         workingLogInfo?.endTime
			        	                       )
			        	                     : "00:00:00"}
			        	                 </td>
			        	               )}
			        	             </tr>
			        	           ))
			        	         ) : (
			        	           <tr>
			        	             <td colSpan={3} className="text-center">
			        	               <span className="fw-bolder">No Data Found</span>
			        	             </td>
			        	           </tr>
			        	         )}
			        	       </tbody>
			        	     </Table>
			        	   </>
			        	 )}

			          
			          { notificationRecordType !== "" && notificationRecordType === 'Early Clock Out'  && (
				          <CardBody className="px-2 py-0 early-clock-out-div">
			        		    <Row>
				                <Col xl={6}>
			                      <FormGroup>
				                      <textarea
				                      id="early_clock_out_remark"
				                      name="early_clock_out_remark"
				                      placeholder="Early Clock Out Reason/ Remark"
				                      type="textarea"
			                    	  onChange={(e) => {
			                    		  handleEarlyClockOutRemark(e);
			  	                      }}
				                      rows={3}
				                      className={"form-control"}
				                    />
			                      </FormGroup>
			                      </Col>
			                      <Col xl={6}>
			                      	<Button color="success" className="btn-sm m-0" 
			                      		onClick={() => {
			                      			setEarlyClockOutStatus("approve");
			                      			approveRejectEarlyClockOut();
					                    }}
			                      	>Approve</Button>
			                      	<Button color="danger" className="btn-sm m-2" 
			                      		onClick={() => {
			                      			setEarlyClockOutStatus("reject");
			                      			approveRejectEarlyClockOut();
					                    }}
			                      	>Reject</Button>
			                      
			                      </Col>
			                      </Row>
		      		    </CardBody>
	      		    )}
			      </Card>
			      </ModalBody>
			      <ModalFooter>
			      
			      	<>
				      	{ notificationRecordType !== "" && notificationRecordType === 'block_user_screen'  && (
			      				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				resendUserOTP()
					                    }}
						      			>
						      			Resend OTP
						      		</Button>
			      					<Button color="success" className="btn-sm m-2"
						      			onClick={(e) => {
						      				validateUserOTP()
					                    }}
						      			>
						      			Validate OTP
						      		</Button>
			      				</>
			      				
			      		)}
				      	{ notificationRecordType !== "" && notificationRecordType === 'MISS_CLOCK_IN'  && (
			      				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				updateNotificationStatus()
					                    }}
						      			>
						      			Close
						      		</Button>
			      				</>
			      				
			      		)}
				      	{ notificationRecordType !== "" && notificationRecordType === 'EMPLOYEE_SCHEDULE'  && (
			      				<>
			      				<Button color="success" className="btn-sm m-2" 
					      			onClick={(e) => {
					      				updateEmployeeScheduleReminderStatus('completed')
				                    }}
					      			>Mark As Completed
					      		</Button>
				      			<Button color="danger" className="btn-sm m-2" 
					      			onClick={(e) => {
					      				updateEmployeeScheduleReminderStatus('pending')
				                    }}
					      			>Mark As Pending
					      		</Button>
			      				</>
			      				
			      		)}
				      	{ notificationRecordType !== "" && notificationRecordType === 'Late Clock Out'  && (
				      	<>
			              <Button
			                color="success"
			                className="btn-sm m-0"
			                onClick={() => updateLateClockOutStatus("reminder")}
			              >
			                I am Calling
			              </Button>

			              <Button
			                color="danger"
			                className="btn-sm m-2"
			                onClick={() => updateLateClockOutStatus("continue")}
			              >
			                Keep Continue
			              </Button>
			            </>
				      	)}
						{ notificationRecordType !== "" && notificationRecordType === 'not_seated_saloon'  && (
			      				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				updateNotificationStatus()
					                    }}
						      			>
						      			Close
						      		</Button>
			      				</>
			      				
			      		)}
			      		{ notificationRecordType !== "" && notificationRecordType === 'assign_saloon_seat'  && (
			      				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				updateNotificationStatus()
					                    }}
						      			>
						      			Close
						      		</Button>
			      				</>
			      				
			      		)}
			      		{ notificationRecordType !== "" && notificationRecordType === 'seat_reassign_seat_request'  && (
			      				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				updateNotificationStatus()
					                    }}
						      			>
						      			Close
						      		</Button>
			      				</>
			      				
			      		)}
			      		{ notificationRecordType !== "" && notificationRecordType === 'send_seat_request_approve'  && (
			      				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				updateNotificationStatus()
					                    }}
						      			>
						      			Close
						      		</Button>
			      				</>
			      				
			      		)}
						{ notificationRecordType !== "" && notificationRecordType === 'seat_accept_request'  && (
				  				<>
				      				<Button color="dark" className="btn-sm m-2"
						      			onClick={(e) => {
						      				approvedSeatRequest()
					                    }}
						      			>
						      			Accept
						      		</Button>
				  				</>
				  				
				  		)}
						{ notificationRecordType !== "" && notificationRecordType === 'seat_pending_request'  && (
									<>
										<Button color="dark" className="btn-sm m-2"
										disabled={ seatedShopDetails?.length > 0 ? 'disabled' : '' }	
						      			onClick={(e) => {
						      				updateNotificationStatus()
						                }}
						      			>
						      			Close
						      		</Button>
									</>
									
							)}
							{ notificationRecordType !== "" && notificationRecordType === 'no_sales_drawer_open'  && (
								<>
									<Button color="success" className="btn-sm m-2"
									onClick={(e) => {
					      				updateNoSalesOpenDrawerRequest()
					                }}
					      			>
					      			Submit
					      		</Button>
								</>
								
						)}
			      		
			      	</>
			      </ModalFooter>
			</Modal>
		)}

		{sendSeatAllocationPopup && (
				  <Modal isOpen={sendSeatAllocationPopup}  size="lg" centered>
		    		  	<Card>
		    		  		<CardHeader>
		    		  			<CardTitle tag="h4">Salon Allocated Request</CardTitle>
		    		  		</CardHeader>
		    		        <div className="d-flex justify-content-center">
		    		        	<div className="w-100">
		    		        	<CardBody>
			    		          {(() => {
			    		            return seatedShopDetails.map((seatedShopDetail, index) => (
			    		              <Row key={index}>
			    		                <Col xl={6}>
			    		                  <FormGroup>
			    		                    <Label for="manager_selection"><b>Salon</b></Label>
			    		                    <input
			    	                          placeholder="Salon Name"
			    	                          type="text"
			    	                          disabled="disabled"
			    	                          value={seatedShopDetail.name}
			    	                          className={ "form-control"}
			    	                        />
			    		                  </FormGroup>
			    		                </Col>
			    		                <Col xl={6}>
			  	    		              <FormGroup>
			    		                    <Label for="manager_selection"><b>Select Manager</b></Label>
			    		                    <Select options={usersOptions} name={"new_manager_for_shop_" + seatedShopDetail.id } 
			    		                    onChange={(e) => {
			    		                    	setNewManageIds(e.value, "new_manager_for_shop_" + seatedShopDetail.id);
			    		                    }}
			    		                    closeMenuOnSelect={true} />
			    		                    
			    		                  </FormGroup>
			    		                </Col>
			    		              </Row>
			    		            ))
			    		          })()}
			    		          </CardBody>
		    		            </div>
		    		        </div>
		    		  </Card>
		    		  <ModalFooter>
		    		  	<Button color="primary" 
		    		  		onClick={(e) => {
		    		  			sendSeatToOtherManager();
		    		  		}}
		    		  	>Submit</Button>
		    		  	<Button color="secondary"
		    		  		onClick={(e) => {
		    		  			setSendSeatAllocationPopup(false);
		    		  		}} 
		    		  	>Close</Button>
		    		  </ModalFooter>
				  </Modal>        
		  )}


	  
	  
        </div>
      </div>
    </main>
  );
};

export default AuthenticatedLayout;
